let INITIAL_MAX_HEIGHT = 122
const wrappers = document.querySelectorAll(".social-medias__socials-list")

const resizeContainer = (container) => {
  const containerItems = container.querySelectorAll("li")

  containerItems.forEach((item) => {
    const itemBoundaries = item.getBoundingClientRect()
    const isItemBreakingContainer =
      itemBoundaries.x + itemBoundaries.width > window.innerWidth ||
      itemBoundaries.x + itemBoundaries.width < 0

    if (isItemBreakingContainer) {
      const newMaxHeight = INITIAL_MAX_HEIGHT + 2
      container.style.maxHeight = `${newMaxHeight}px`

      INITIAL_MAX_HEIGHT = newMaxHeight

      return resizeContainer(container)
    }

    return
  })
}

window.addEventListener("load", () => wrappers.forEach(resizeContainer))
window.addEventListener("resize", () => wrappers.forEach(resizeContainer))
